import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { QRCodeSVG } from 'qrcode.react'

import { formatDate, formatMoney, regexPhoneNumber, chequeNumber } from 'helpers/helpers'
import { toNumber, getPrintProduct, drawingForCheque } from 'helpers/chequePrint'
import { loadComplaintBot, getComplaintBot, getComplaintBotUrl } from 'helpers/complaintBot'


function Cheque80({ data = { products: [] }, printChequeRef, show = false }) {
	const { t } = useTranslation()

	const [products, setProducts] = useState([]);
	const [accessories, setAccessories] = useState([]);
	const [tunikofons, setTunikofons] = useState([]);
	const [profs, setProfs] = useState([]);
	const [totalAmount, setTotalAmount] = useState({
		accessoryTotalQuantity: 0,
		productsTotalPrice: 0,
		productsTotalQuantity: 0,
	});

	/* SHIKOYAT QR i — chek pastida. Nom localStorage dan SINXRON o'qiladi
	   (chop etish darhol bo'ladi, so'rov ulgurmaydi), fonda esa yangilanadi. */
	const [botName, setBotName] = useState(getComplaintBot())
	useEffect(() => {
		let alive = true
		loadComplaintBot().then(() => { if (alive) setBotName(getComplaintBot()) })
		return () => { alive = false }
	}, [])
	const botUrl = botName ? getComplaintBotUrl() : null

	useEffect(() => {
		const productsData = data?.products || [];

		const type1 = [];
		const accessory = {
			children: [],
			preparedChildren: [],
			totalQuantity: 0,
			totalPrice: 0,
		};
		const tunikofon = {
			children: [],
			preparedChildren: [],
			totalQuantity: 0,
			totalPrice: 0,
		};
		const prof = {
			children: [],
			preparedChildren: [],
			totalQuantity: 0,
			totalPrice: 0,
		};

		const newTotalAmount = {
			productsTotalPrice: 0,
			productsTotalQuantity: 0,
			returnedSqM: 0,
			returnedMetr: 0,
			returnedCount: 0,
			returnedAmount: 0,
		};

		productsData.forEach(product => {
			const printProduct = getPrintProduct(product);
			if (printProduct.print_quantity <= 0) return;
			newTotalAmount.returnedAmount += toNumber(printProduct.print_returned_amount);
			if (product.product_type === 5 && !product.is_prepared) {
				newTotalAmount.returnedSqM += toNumber(printProduct.print_returned_sq_m);
			} else if ((product.product_type === 3 || product.product_type === 4) && !product.is_prepared) {
				newTotalAmount.returnedMetr += toNumber(printProduct.print_returned_metr);
			} else {
				// Produkt (tur 1) va barcha tayyor mahsulotlar — DONA bilan qaytariladi
				newTotalAmount.returnedCount += toNumber(printProduct.print_returned_metr);
			}

			if (product.product_type === 1) {
				type1.push(printProduct);
				newTotalAmount.productsTotalQuantity += printProduct.print_quantity;
				newTotalAmount.productsTotalPrice += printProduct.print_total_price;
			} else if (product.product_type === 3) {
				if (product.is_prepared) {
					accessory.preparedChildren.push(printProduct);
					accessory.totalQuantity += printProduct.print_quantity;
				} else {
					accessory.children.push(printProduct);
					accessory.totalQuantity += printProduct.print_metr;
				}
				accessory.totalPrice += printProduct.print_total_price;
			} else if (product.product_type === 5) {
				if (product.is_prepared) {
					tunikofon.preparedChildren.push(printProduct);
					tunikofon.totalQuantity += printProduct.print_quantity;
				} else {
					tunikofon.children.push(printProduct);
					tunikofon.totalQuantity += printProduct.print_sq_m;
				}
				tunikofon.totalPrice += printProduct.print_total_price;
			} else if (product.product_type === 4) {
				if (product.is_prepared) {
					prof.preparedChildren.push(printProduct);
					prof.totalQuantity += printProduct.print_quantity;
				} else {
					prof.children.push(printProduct);
					prof.totalQuantity += printProduct.print_metr;
				}
				prof.totalPrice += printProduct.print_total_price;
			}
		});

		setProducts(type1);
		setProfs(prof);
		setAccessories(accessory);
		setTunikofons(tunikofon);
		setTotalAmount(newTotalAmount);
	}, [data.products]);

	const printTotalAmount =
		data.total_amount !== undefined
			? toNumber(data.total_amount)
			: toNumber(profs.totalPrice) +
			toNumber(accessories.totalPrice) +
			toNumber(tunikofons.totalPrice) +
			toNumber(totalAmount.productsTotalPrice)
	const paidAmount = data.net_paid !== undefined ? toNumber(data.net_paid) : toNumber(data.paid)
	const chequeDebt = data.net_cheque_debt !== undefined ? toNumber(data.net_cheque_debt) : toNumber(data.cheque_debt)

	// ===== 80mm chek maketi — inline uslub (shared CSS'ga tegilmaydi) =====
	const st = {
		wrap: { fontSize: '14px', lineHeight: 1.5, color: '#000', fontVariantNumeric: 'tabular-nums' },
		biz: { textAlign: 'center', color: '#000', fontSize: '10.5px', lineHeight: 1.3 },
		sepSolid: { borderTop: '1px solid #111722', margin: '8px 0' },
		sepDash: { borderTop: '1px dashed #aab0bb', margin: '7px 0' },
		sepStrong: { borderTop: '2px solid #111722', margin: '9px 0' },
		row: { display: 'flex', justifyContent: 'space-between', gap: '10px', alignItems: 'baseline' },
		k: { color: '#000' },
		v: { textAlign: 'right', fontWeight: 600 },
		idK: { fontSize: '26px', fontWeight: 900, color: '#000', letterSpacing: '.3px' },
		idV: { fontSize: '15px', fontWeight: 700, color: '#000', textAlign: 'right', whiteSpace: 'nowrap' },
		delWrap: { textAlign: 'center', margin: '8px 0 3px' },
		delK: { color: '#000', fontSize: '12px' },
		delV: { fontSize: '19px', fontWeight: 900, letterSpacing: '.3px' },
		sec: { fontWeight: 800, fontSize: '15px', letterSpacing: '.5px' },
		pname: { fontWeight: 700 },
		roll: { color: '#000', fontWeight: 600 },
		calc: { fontWeight: 700 },
		hl: { background: '#fff2c2', padding: '0 3px', borderRadius: '2px' },
		money: { fontWeight: 700, whiteSpace: 'nowrap', textAlign: 'right' },
		jami: { fontWeight: 800 },
		bigT: { textAlign: 'center', fontWeight: 800, fontSize: '15px', letterSpacing: '.5px' },
		bigV: { textAlign: 'center', fontWeight: 900, fontSize: '23px', marginTop: '1px' },
		foot: { textAlign: 'center', color: '#000', fontSize: '11px', lineHeight: 1.4, marginTop: '2px' },
		/* Chek pastidagi shikoyat QR i */
		qrTitle: { textAlign: 'center', fontWeight: 800, fontSize: '13px', letterSpacing: '.4px', marginTop: '6px' },
		qrSub: { textAlign: 'center', fontSize: '10.5px', marginTop: '1px' },
		qrBox: { display: 'flex', justifyContent: 'center', marginTop: '5px' },
		qrBot: { textAlign: 'center', fontWeight: 700, fontSize: '12px', marginTop: '3px', letterSpacing: '.3px' },
	}
	const MU = 'm'

	/* CHEREPITSA: BOSHI + SHAG (2026-08-27). Sotuvchi kiritadi, chekda ko'rinadi —
	   «har biri qo'lda yozilsa adashilmovchilik bo'lmaydi» (egasi). Maydonlar
	   qator darajasida (cheques_products), faqat kiritilganda chiqadi. */
	const tileLine = (item) => {
		const has = v => v !== null && v !== undefined && v !== ''
		if (!has(item.tile_start_sm) && !has(item.tile_step_sm)) return null
		return (
			<div style={{ ...st.calc, fontSize: '15px' }}>
				{has(item.tile_start_sm) && <>{t('tile_start').toUpperCase()}: <span style={st.hl}>{formatMoney(item.tile_start_sm, 1)} {t('sm_unit')}</span></>}
				{has(item.tile_start_sm) && has(item.tile_step_sm) && ' · '}
				{has(item.tile_step_sm) && <>{t('tile_step').toUpperCase()}: <span style={st.hl}>{formatMoney(item.tile_step_sm, 1)} {t('sm_unit')}</span></>}
			</div>
		)
	}

	// Bitta mahsulot bloki. kind: 'metr' (prof/aksessuar), 'kv' (tunikofon), 'count' (produkt/tayyor)
	const productBlock = (item, index, kind) => {
		const head = (
			<div>
				<span style={st.pname}>{index + 1}. {item.product_name}</span>
				{item.element_name && <span style={st.roll}> — {item.element_name}</span>}
			</div>
		)
		if (kind === 'metr' || kind === 'kv') {
			const metrLine = (
				<div style={st.calc}>
					{formatMoney(item.element_quantity, 3)} {MU} × {formatMoney(item.print_roll_quantity, 3)} {t('piece')} = <span style={st.hl}>{formatMoney(item.print_metr, 3)} {MU}</span>
				</div>
			)
			if (kind === 'kv') {
				return (
					<div>
						{head}
						{/* TUNUKAFON CHIZMASI — 2026-08-13 da qo'shildi (foydalanuvchi qarori).
						    Ilgari chizma FAQAT aksessuarda bor edi: mijoz karniz bilan
						    doskani nomiga qarab ajratishi kerak edi, holbuki ikkisi
						    butunlay boshqa shakl. Mijoz rejimida burchak va rang tomoni
						    chizilmaydi — ular sexning ko'rsatmasi. */}
						{drawingForCheque(item, 'client') &&
							<img src={drawingForCheque(item, 'client')} alt=""
								style={{ display: 'block', width: '100%', maxWidth: '210px', margin: '3px auto 1px' }} />}
						{metrLine}
						<div style={st.row}>
							{/* Eni — chizma bo'lsa chizmaniki (getPrintProduct: print_width) */}
							<span style={st.k}>{formatMoney(item.print_metr, 3)} {MU} × {formatMoney(item.print_width ?? item.width, 3)} {MU}</span>
							<span style={st.money}>{formatMoney(item.print_sq_m, 3)} {t('sq_m')}</span>
						</div>
						<div style={st.row}>
							<span style={st.k}>{formatMoney(item.print_sq_m, 3)} {t('sq_m')} × {formatMoney(item.sale_price)}</span>
							<span style={st.money}>{formatMoney(item.print_total_price)}</span>
						</div>
					</div>
				)
			}
			return (
				<div>
					{head}
					{/* AKSESSUAR CHIZMASI — mijoz nima olayotganini ko'rsin.

				    ⚠️ UZUNLIK — ONGLI QAROR (2026-08-13), qisqartirmang.
				    Har mahsulot ~5.7 sm joy egallaydi (chizma ~3.5 + matn ~2.2).
				    15 ta mahsulotli buyurtmada chek ~85 sm tasma bo'ladi.
				    Foydalanuvchiga to'rt variant taklif qilindi (ko'p bo'lsa
				    chizmasiz / chizmani kichraytirish / A4 ga o'tish / tegmaslik) —
				    u ATAYLAB «uzun bo'lsa bo'laversin, mijoz nima olayotganini
				    to'liq ko'rsin» dedi. Ish topshirig'ida (sex) esa aksincha:
				    tunukafon uchun A4 varaq qilindi (ChequeWorkA4). */}
					{drawingForCheque(item, 'client') &&
						<img src={drawingForCheque(item, 'client')} alt=""
							style={{ display: 'block', width: '100%', maxWidth: '210px', margin: '3px auto 1px' }} />}
					{tileLine(item)}
					{metrLine}
					<div style={st.row}>
						<span style={st.k}>{formatMoney(item.print_metr, 3)} {MU} × {formatMoney(item.sale_price)}</span>
						<span style={st.money}>{formatMoney(item.print_total_price)}</span>
					</div>
				</div>
			)
		}
		return (
			<div>
				{head}
				{tileLine(item)}
				<div style={st.row}>
					<span style={st.k}>{formatMoney(item.print_quantity, 3)} {t('piece')} × {formatMoney(item.sale_price)}</span>
					<span style={st.money}>{formatMoney(item.print_total_price)}</span>
				</div>
			</div>
		)
	}

	// Bo'lim: sarlavha + mahsulotlar (orasida ajratgich) + Жами
	const section = (title, items, kind, totalQty, qtyUnit, totalPrice) => {
		if (!items || items.length === 0) return null
		return (
			<div>
				<div style={st.sec}>{title}</div>
				<div style={st.sepDash}></div>
				{items.map((it, i) => (
					<React.Fragment key={i}>
						{i > 0 && <div style={st.sepDash}></div>}
						{productBlock(it, i, kind)}
					</React.Fragment>
				))}
				<div style={st.sepDash}></div>
				<div style={st.row}>
					<span style={st.jami}>{t('total')}{totalQty ? ` (${formatMoney(totalQty, 3)} ${qtyUnit})` : ''}</span>
					<span style={{ ...st.money, ...st.jami }}>{formatMoney(totalPrice)}</span>
				</div>
				<div style={st.sepSolid}></div>
			</div>
		)
	}

	const bizLine = [data.pos_address, regexPhoneNumber(data.pos_phone)].filter(Boolean).join(' · ')

	// MANZIL: tanlangan hudud nomi (masalan «Chem») + eski erkin matnli manzil (eski cheklarда bor).
	// Ikkalasi ham bo'lsa vergul bilan; ikkalasi ham bo'sh bo'lsa satr umuman chiqmaydi.
	const addressLine = [data.client_region, data.address].filter(Boolean).join(', ')

	// Qaytarilgan miqdor yorlig'i: metr (aksessuar/prof) + kv.m (tunikofon)
	const retQtyParts = []
	if (totalAmount.returnedMetr > 0) retQtyParts.push(`${formatMoney(totalAmount.returnedMetr, 3)} ${MU}`)
	if (totalAmount.returnedSqM > 0) retQtyParts.push(`${formatMoney(totalAmount.returnedSqM, 3)} ${t('sq_m')}`)
	if (totalAmount.returnedCount > 0) retQtyParts.push(`${formatMoney(totalAmount.returnedCount, 3)} ${t('piece')}`)
	const retQtyStr = retQtyParts.length ? ` (${retQtyParts.join(' + ')})` : ''

	return (
		<div className={`${show ? '' : 'd-none'}`}>
			<div className={`cheque print ${show ? 'p-3' : 'print'} w80mm`} ref={printChequeRef} style={st.wrap}>
				{/* Logo + biznes.
				    ⚠️ Logotip YO'Q bo'lsa BEGONA rasm bosilmaydi. Ilgari zaxira sifatida
				    ilovaning o'z logotipi (ASProfil) chiqardi va 12 tenantdan 6 tasi —
				    Ferrox.uz, MAX PROF, FAYZ PROFIL kabi raqobatchilar — o'z MIJOZIGA
				    ASProfil logotipi bosilgan chek bergan. Zaxira zanjiri endi:
				    logotip -> korxona NOMI (pastda matn bilan chiqadi) -> hech narsa.
				    Shu naqsh shikoyat plakatida allaqachon to'g'ri ishlaydi. */}
				{data.logo &&
					<div style={{ textAlign: 'center', marginBottom: '2px' }}>
						<img src={`https://backend.tameer.uz/uploads/poses/${data.logo}`} alt="" />
					</div>
				}
				{data.pos_name && <div style={{ ...st.biz, fontWeight: 700, fontSize: data.logo ? '12px' : '15px', color: '#000' }}>{data.pos_name}</div>}
				{bizLine && <div style={st.biz}>{bizLine}</div>}
				<div style={st.sepSolid}></div>

				{/* № + sana */}
				<div style={{ ...st.row, alignItems: 'center' }}>
					<span style={st.idK}>№ {chequeNumber(data)}</span>
					<span style={st.idV}>{formatDate(data.cheque_opened_at, "dd.MM.yyyy HH:mm")}</span>
				</div>
				<div style={st.sepSolid}></div>

				{/* Sotuvchi bloki */}
				<div style={st.row}><span style={st.k}>{t('seller')}</span><span style={st.v}>{data.cashier_name}</span></div>
				<div style={st.row}><span style={st.k}>{t('phone')}</span><span style={{ ...st.v, whiteSpace: 'nowrap' }}>{regexPhoneNumber(data.cashier_phone)}</span></div>
				<div style={st.sepSolid}></div>

				{/* Mijoz bloki */}
				<div style={st.row}><span style={st.k}>{t('client')}</span><span style={st.v}>{data.client_name}</span></div>
				<div style={st.row}><span style={st.k}>{t('phone')}</span><span style={{ ...st.v, whiteSpace: 'nowrap' }}>{regexPhoneNumber(data.client_phone)}</span></div>
				{data.courier_login && <div style={st.row}><span style={st.k}>{t('courier')}</span><span style={st.v}>{data.courier_name}</span></div>}
				{data.delivery_type_id && <div style={st.row}><span style={st.k}>{t('delivery_type')}</span><span style={st.v}>{data.delivery_type_name}</span></div>}
				{addressLine && <div style={st.row}><span style={st.k}>{t('address')}</span><span style={st.v}>{addressLine}</span></div>}

				{/* Yetkazib berish sanasi — yirik */}
				{data.delivery_date &&
					<div style={st.delWrap}>
						<div style={st.delK}>{t('delivery_date')}</div>
						<div style={st.delV}>{formatDate(data.delivery_date, "dd.MM.yyyy HH:mm")}</div>
					</div>}
				<div style={st.sepSolid}></div>

				{/* Bo'limlar */}
				{section(t('profiled_sheeting'), profs.children, 'metr', profs.totalQuantity, MU, profs.totalPrice)}
				{section(t('prepared_prof'), profs.preparedChildren, 'count', null, null, profs.totalPrice)}
				{section(t('accessory'), accessories.children, 'metr', accessories.totalQuantity, MU, accessories.totalPrice)}
				{section(t('prepared_accessory'), accessories.preparedChildren, 'count', null, null, accessories.totalPrice)}
				{section(t('tunikofon'), tunikofons.children, 'kv', tunikofons.totalQuantity, t('sq_m'), tunikofons.totalPrice)}
				{section(t('prepared_tunicophone'), tunikofons.preparedChildren, 'count', null, null, tunikofons.totalPrice)}
				{section(t('products'), products, 'count', null, null, totalAmount.productsTotalPrice)}

				{/* Jamlanma */}
				<div style={st.sepStrong}></div>
				<div style={st.bigT}>{t('to_pay')}</div>
				<div style={st.bigV}>{formatMoney(printTotalAmount)}</div>
				<div style={st.sepDash}></div>
				{toNumber(data.discount_amount) > 0 &&
					<div style={st.row}><span style={st.k}>{t('discount')}</span><span style={st.v}>{formatMoney(data.discount_amount)}</span></div>}
				<div style={st.row}><span style={st.k}>{t('paid')}</span><span style={st.v}>{formatMoney(paidAmount)}</span></div>
				{toNumber(data.total_returned_amount) > 0 &&
					<div style={st.row}>
						<span style={st.k}>{t('return')}{retQtyStr}</span>
						<span style={{ ...st.v, color: '#b42318' }}>- {formatMoney(data.total_returned_amount)}</span>
					</div>}
				<div style={st.sepDash}></div>
				<div style={st.row}><span style={st.k}>{t('order_debt')}</span><span style={st.v}>{formatMoney(chequeDebt)}</span></div>
				<div style={st.row}><span style={st.k}>{t('previous_debt')}</span><span style={st.v}>{formatMoney(Math.abs(Number(data.client_balance) + chequeDebt))}</span></div>
				<div style={{ ...st.row, ...st.jami }}><span>{t('total_debt')}</span><span style={{ ...st.v, ...st.jami }}>{formatMoney(Math.abs(Number(data.client_balance)))}</span></div>

				{/* OMBOR: haydovchi shu chek uchun QANCHA pul olib kelishi kerak.
				    Ataylab «Жами қарз» EMAS — mijozning eski qarzi boshqa yuk/boshqa
				    kunning ishi; bu qog'ozda faqat SHU chekning qoldig'i turadi.
				    Faqat omborchi chiqarganda ko'rinadi (Board.js `driver_note`). */}
				{data.driver_note && chequeDebt > 0 &&
					<>
						<div style={st.sepStrong}></div>
						<div style={st.bigT}>{t('driver_collect')}</div>
						<div style={st.bigV}>{formatMoney(chequeDebt)}</div>
						<div style={{ ...st.foot, marginTop: 0 }}>{t('for_this_cheque')}</div>
					</>}

				<div style={st.sepStrong}></div>
				<div style={st.foot}>
					{t('thanks')}
					{data.pos_name && <><br />{[data.pos_name, bizLine].filter(Boolean).join(' · ')}</>}
				</div>

				{/* ═══ TAKLIF VA SHIKOYAT ═══
				    Mijoz chekni qo'lida olib ketadi — fikr bildirish uchun eng qulay joy shu.
				    Bot sozlanmagan bo'lsa blok UMUMAN chiqmaydi (bo'sh QR chiqmasin).
				    QR — issiq printerda ham o'qilsin deb OQ fonda, qora ramkasiz. */}
				{botUrl &&
					<>
						<div style={st.sepDash}></div>
						<div style={st.qrTitle}>{t('poster_title')}</div>
						<div style={st.qrSub}>{t('poster_subtitle')}</div>
						<div style={st.qrBox}>
							<QRCodeSVG value={botUrl} size={120} level="M" bgColor="#ffffff" fgColor="#000000" />
						</div>
						<div style={st.qrBot}>@{botName}</div>
					</>
				}
			</div>
		</div>
	)
}

export default Cheque80
